// extracted by mini-css-extract-plugin
export default {"companyPageStack":"CompanyPagePage_companyPageStack__j3aaj"};